const value = {
    cardTitle: 'Управление контентом в Знаниях',
    cardDescription: 'Импорт и экспорт контента. Позволяет обновлять юниты для обучения.',
    importButton: 'Импорт',
    exportButton: 'Экспорт',
    exportPage: {
      toggle: 'Выбрать все юниты',
      button: 'Экспорт',
      state: 'Скачивание',
      search: 'Поиск по юнитам',
      modalTitle: 'Введите пароль для экспорта',
      confirm: 'OK',
      decline: 'Отмена',
      inputPlaceholder: 'Пароль',
      passwordHint: 'Допустимы буквы, цифры и спецсимволы.',
      notificationExport: 'Экспорт завершён',
      error: {
        VALIDATION_MESSAGE: {
          minLength: 'Длина меньше 8 символов',
          maxLength: 'Длина больше 256 символов',
          weakPassword: 'Пароль должен содержать заглавные и строчные буквы, специальные символы, цифры',
        },
      },
    },
    importPage: {
      dropZoneDescriptionShort: 'Перетащите файлы сюда…',
      dropZoneDescription: 'Перетащите файлы сюда или нажмите для выбора',
      clearAll: 'Удалить все',
      toggle: 'Обновить зависимости',
      tooltip:
        'При обновлении зависимостей у вас удалятся ваши кастомные настройки в разделах Характеристика АС и Проектные роли.',

      fileExist: 'Файл «{{name}}» уже есть в списке',
      fileNotZip: 'Файл «{name}» не является .zip',
      fileTooLarge: 'Файл «{{name}}» превышает 50 МБ',
      fileNotSupported: 'Файл «{{name}}» не поддерживается',
      importError: 'Ошибка импорта: {{message}}',
      importErrorDefault: 'Ошибка импорта. Попробуйте ещё раз.',

      modalTitle: 'Введите пароль для импорта',
      inputPlaceholder: 'Пароль',
      confirm: 'ОК',
      decline: 'Отмена',
      passwordError: 'Неверный пароль. Попробуйте ещё раз.',

      button: 'Импорт',
      state: 'Импорт…',

      pending: 'Ожидает импорта',
      unitState: 'Файл импортирован',
    },
  };

export default value;
